import * as angular from 'angular';
import LocalStorageService from './local-storage.service';

export default angular
  .module('LocalStorageModule', [])
  .service('LocalStorageService', LocalStorageService)
  .name;



// WEBPACK FOOTER //
// ./src/app/core/local-storage/local-storage.module.js